import axios, { AxiosProgressEvent } from 'axios';

import { DocumentUploadState } from '../domain/document-collection';
import {
  AnalyticsData,
  CollectDocumentsNextAction,
  Promotion,
  QualificationStepRequest,
  QualificationStepResponse,
} from '../domain/qualification';
import { VGS_INBOUND_URL } from '../env';
import { cleanJson, Json } from '../general/utils/form';

const nextStep = async (request: QualificationStepRequest): Promise<QualificationStepResponse> => {
  return axios
    .post<QualificationStepResponse>(`${VGS_INBOUND_URL}/qualification/next-step`, cleanJson(request as Json))
    .then((res) => res.data);
};

const uploadDocuments = async (
  documents: DocumentUploadState[],
  nextAction: CollectDocumentsNextAction,
  progressCallback: (
    event: Pick<DocumentUploadState, 'documentName' | 'entityToken'> & {
      progress: number;
      progressComputable: boolean;
      uploading: boolean;
    },
  ) => void,
): Promise<void> => {
  for (const document of documents) {
    const formData = new FormData();
    formData.append('document', document.file!);
    formData.append('document_name', document.documentName);
    formData.append('entity_token', document.entityToken);
    formData.append('next_action', nextAction);

    await axios.post('/qualification/upload_document', formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
      onUploadProgress: (event: AxiosProgressEvent) => {
        progressCallback({
          documentName: document.documentName,
          entityToken: document.entityToken,
          progress: event.total && event.lengthComputable ? Math.round((100 * event.loaded) / event.total) : 0,
          progressComputable: event.lengthComputable,
          uploading: true,
        });
      },
    });
    progressCallback({
      documentName: document.documentName,
      entityToken: document.entityToken,
      progress: 100,
      progressComputable: true,
      uploading: false,
    });
  }
};

const getPromotion = async (promoCode: string): Promise<Promotion> => {
  return axios.get<Promotion>(`/qualification/active_promotion/${promoCode}`).then((res) => res.data);
};

const getAnalyticsData = (): Promise<AnalyticsData> =>
  axios.get<AnalyticsData>('/qualification/analytics').then((res) => res.data);

export { nextStep, uploadDocuments, getPromotion, getAnalyticsData };
